import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { saveBrand } from "../../redux/actions";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import AddConciergeModal from "./components/AddConciergeModal";
import "./index.css";
import plugImg from "../../assets/media/plus.png";
import checkImg from "../../assets/media/check.png";
import { TerritoryOptions } from "../../Constants/retailer";
import { loveImg } from "./constants/assets";
class AutoConcierge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      loading: false,
      loading_script: "",
      postData: null,
      concierges: [],
      users: [],
      selectedWeek: 0,
      selectedDate: null,
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      Firebase.getBrandDataByID(brand, async (brand_data) => {
        brand_data.id = brand;
        this.props.dispatch(saveBrand(brand_data));
        this.setState(
          {
            logo: brand_data.logo,
            icon: brand_data.icon,
            brand_name: brand_data.name,
            brand_url: brand_data.url,
            territory: brand_data.territory || TerritoryOptions[0],
            hex: brand_data.hex,
            is_property_brand: brand_data.is_property_brand
              ? brand_data.is_property_brand
              : false,
          },
          () => {
            Firebase.getConciergeBotsByBrand(
              brand_data.name,
              this.subscribeConcierges
            );
          }
        );
      });
    }
  }

  subscribeConcierges = (concierges) => {
    this.setState({ concierges, loading: false });
  };

  subscribeUsers = (users) => {
    this.setState({ users });
  };

  showPlans = () => {
    let PlanItem = ({ date }) => {
      const concierge = this.state.concierges.find((obj) =>
        date.isSame(new Date(obj.time), "day")
      );
      let topic = concierge && concierge.topic;
      if (topic) {
        return (
          <div className="calendar-item">
            <p>{topic}</p>
            <img className="checkmark" src={checkImg} alt="checkmark" />
          </div>
        );
      }
      const isPastDay = date.isBefore(moment(), "day");
      return (
        <button
          className="add-plan-btn"
          type="button"
          data-toggle="modal"
          data-target="#add_concierge_modal"
          onClick={() => {
            this.setState({ selectedDate: date });
          }}
          disabled={isPastDay}
        >
          {!isPastDay && (
            <img src={plugImg} className="default-item" alt="default" />
          )}
        </button>
      );
    };

    return [0, 1, 2, 3, 4, 5, 6].map((i) => (
      <div key={i} className="plan">
        <PlanItem date={this.getWeekDate(i)} />
      </div>
    ));
  };

  getWeekDate = (i) => {
    if (moment().isSame(moment().startOf("week"))) {
      return moment().add("days", this.state.selectedWeek * 7 + i - 6);
    }
    return moment()
      .startOf("week")
      .add("days", this.state.selectedWeek * 7 + i + 1);
  };
  showDays = () => {
    const weekDays = moment.weekdaysShort();
    return [0, 1, 2, 3, 4, 5, 6].map((item, index) => {
      const date = this.getWeekDate(index);
      if (date.isSameOrAfter(moment(), "day"))
        return (
          <p key={index} style={{ width: "13%" }}>
            {weekDays[date.get("day")]} {date.format("DD[th] MMM")}
          </p>
        );
      return <p key={index} style={{ width: "13%" }}></p>;
    });
  };

  showWeekBar = () => {
    const { selectedWeek } = this.state;
    return (
      <div className="week-bar">
        <p style={{ fontWeight: 700 }}>Schedule concierge auto-interactions</p>
        {[0, 1, 2, 3, 4].map((obj) => (
          <button
            key={obj}
            className={`btn week_btn ${selectedWeek === obj ? "active" : ""}`}
            onClick={() => {
              this.setState({ selectedWeek: obj }, this.getHotTopic);
            }}
          >
            Week {obj + 1}
          </button>
        ))}
      </div>
    );
  };

  /*
  All func related to posting feed
  */
  handleClickPost = async (conciergeData) => {
    const { brand_name } = this.state;
    const concierge = {
      ...conciergeData.data,
      time: conciergeData.time.valueOf(),
    };
    Firebase.addConciergeBot(concierge, brand_name);
  };

  render() {
    const {
      username,
      role,
      logo,
      brand,
      is_property_brand,
      loading,
      loading_script,
      brand_name,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container" className="concierge-content">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
              <p>{loading_script}</p>
            </div>
          )}
          {this.showWeekBar()}
          <div className="calendar">
            <div className="date">
              <p style={{ width: "9%" }}>Week day</p>
              {this.showDays()}
            </div>
            <div className="plan_row">
              <div className="plan_header">
                <img src={loveImg} alt="goal" />
              </div>
              {this.showPlans()}
            </div>
          </div>
          <AddConciergeModal
            selectedDate={this.state.selectedDate}
            onAdd={this.handleClickPost}
          />
        </main>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    uid: state.uid,
    users: state.users,
    unreads: state.unreads,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AutoConcierge);



// WEBPACK FOOTER //
// ./src/screens/AutoConcierge/index.js